<template>
    <div class="quiz-result">
        <div :class="['quiz-result__top', { 'passed': isPassed, 'failed': !isPassed }]">
            <span class="quiz-result__title">
                <span :class="result.icon"></span>
                {{ result.heading }}
            </span>
            <span class="quiz-result__score-label" v-html="$t('Quiz.your_result')"></span>
            <span class="quiz-result__score">{{ score }}%</span>
            <div class="quiz-result__buttons">
                <TotemButton v-if="!isPassed" color="secondary" :label="$t('Quiz.retake_test_button')" @click="retakeTest" />
                <TotemButton v-if="checkIfCanProgressToNextPart" color="primary" :label="$t('Quiz.next_button')" icon="arrow-right" iconPosition="right" @click="goNext" />
            </div>
        </div>
        <div v-if="results.length === quizLength" class="quiz-result__summary">
            <span v-html="$t('Quiz.number_of_questions_answered_correctly', { numberOfCorrectAnswers: numberOfCorrectAnswers, questionsLength: results.length })"></span>
            <div class="quiz-result__answers">
                <QuizResultItem v-for="(result, index) in results" :result="result" :index="index"/>
            </div>
        </div>
        <ModalCompleteQuiz @retake-test="retakeTest" />
    </div>
</template>

<script>
import QuizResultItem from 'components/coursepage/quiz/QuizResultItem'
import microLearningHelper from 'components/shared/mixins/microLearningHelper'
import ModalCompleteQuiz from 'components/shared/modals/ModalCompleteQuiz'
import { mapGetters } from 'vuex'

export default {
    name: 'quiz-result',
    mixins: [microLearningHelper],
    components: { QuizResultItem, ModalCompleteQuiz },
    props: {
        results: Array,
        isQuizPassed: Boolean,
        quizStatus: Object,
        quizLength: Number
    },
    computed: {
        ...mapGetters({
            microLearningSection: 'MicroLearning/getMicroLearningSection',
            microLearningSections: 'MicroLearning/getMicroLearningSections'
        }),
        numberOfCorrectAnswers() {
            return this.results.filter(result => result.isCorrect).length
        },
        score() {
            return Math.floor((this.numberOfCorrectAnswers / this.results.length) * 100) || this.quizStatus.resultPercentage
        },
        isPassed() {
            return this.isQuizPassed || this.quizStatus.isPassed
        },
        result() {
            return this.isPassed
                ? { heading: this.$t('Quiz.test_passed'), icon: 'icon-checkmark' }
                : { heading: this.$t('Quiz.test_failed'), icon: 'icon-cross' }
        },
        checkIfCanProgressToNextPart() {
            return (this.isPassed || this.results.length === 0) && !this.quizIsLastItem
        },
        quizIsLastItem() {
            return this.microLearningSections[this.microLearningSections.length - 1].elementId === this.microLearningSection.elementId 
        }
    },
    methods: {
        retakeTest() {
            this.$emit('retake-test')
        },
        goNext() {
            if (!this.isPassed) {
                this.$modal.show('complete-quiz')
            } else {
                this.selectMicroLearningSection(1)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.quiz-result {
    &__top {
        font-family: PPAgrandir-Medium, sans-serif;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 40px;
        margin: 0 0 40px;

        &.passed {
            .quiz-result__score,
            [class*=icon-] {
                color: $william;
            }
        }

        &.failed {
            .quiz-result__score,
            [class*=icon-] {
                color: $chestnut;
            }
        }
    }

    &__title {
        font-size: 2.4rem;
        color: $tuatara;
        display: flex;
        gap: 10px;
    }

    &__score-label {
        font-size: 1.6rem;
        color: $emperor;
        margin: 0 0 -30px;
    }

    &__score {
        font-size: 4.4rem;
        color: $william;
    }

    &__buttons {
        display: flex;
        gap: 20px;
    }

    &__summary {
        font-family: PPAgrandir-Medium, sans-serif;
        font-size: 1.6rem;
        color: $emperor;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    &__answers {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
}
</style>
